import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgOrder({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 6a1 1 0 110-2 3 3 0 013 3v12a3 3 0 01-3 3H7a3 3 0 01-3-3V7a3 3 0 013-3 1 1 0 110 2 1 1 0 00-1 1v12a1 1 0 001 1h10a1 1 0 001-1V7a1 1 0 00-1-1zm-7-3h4a1 1 0 010 2h-4a1 1 0 010-2zm-1 7h6a1 1 0 010 2H9a1 1 0 110-2zm0 4h3a1 1 0 110 2H9a1 1 0 010-2z"
        fill={color}
      />
    </svg>
  )
}

export default SvgOrder
